import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { auth } from "../api/endpoints";
import { Btn } from "./ui/Btn";
import { Dialog, FieldLabel, dialogInput } from "./ui/Dialog";
import { F } from "../theme/tokens";

// Changing your own password. It used to be three browser prompt() boxes, which show
// the password in clear text and are easily blocked or dismissed by the browser.

export function ChangePasswordDialog({ onClose }: { onClose: () => void }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  async function submit() {
    if (!current) return setError("Enter your current password.");
    if (next.length < 12) return setError("Use at least 12 characters: this account can suspend users and move escrow.");
    if (next !== confirm) return setError("The two new passwords do not match.");
    setError("");
    setSaving(true);
    try {
      await auth.changePassword(current, next);
      setDone(true);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Could not change the password.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <Dialog title="Change my password" onClose={onClose}>
      {done ? (
        <div style={{ textAlign: "center", padding: "8px 0 4px" }}>
          <CheckCircle2 size={30} style={{ color: "#16a34a", marginBottom: "10px" }} />
          <p style={{ fontSize: "13px", fontFamily: F, margin: "0 0 18px" }}>Your password has been changed.</p>
          <Btn variant="primary" onClick={onClose}>Done</Btn>
        </div>
      ) : (
        <form onSubmit={(e) => { e.preventDefault(); void submit(); }} style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
          <div>
            <FieldLabel>Current password</FieldLabel>
            <input type="password" autoComplete="current-password" autoFocus value={current} onChange={(e) => setCurrent(e.target.value)} style={dialogInput} />
          </div>
          <div>
            <FieldLabel>New password (12+ characters)</FieldLabel>
            <input type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} style={dialogInput} />
          </div>
          <div>
            <FieldLabel>Confirm new password</FieldLabel>
            <input type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} style={dialogInput} />
          </div>
          {error && <p role="alert" style={{ color: "#b91c1c", fontSize: "12px", margin: 0, fontFamily: F }}>{error}</p>}
          <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
            <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
            <Btn variant="primary" onClick={() => void submit()} disabled={saving}>{saving ? "Saving…" : "Change password"}</Btn>
          </div>
        </form>
      )}
    </Dialog>
  );
}
